// Add this as a new component: HoverInfo.js
import React from 'react';

const HoverInfo = ({ position, content }) => {
  if (!position || !content) return null;
  
  const style = {
    left: `${position.x}px`,
    top: `${position.y}px`,
    opacity: 1
  };
  
  return (
    <div className="financial-hover-info" style={style}>
      {content}
    </div>
  );
};

export default HoverInfo;